import { Component, ViewChild, ViewContainerRef, ComponentFactory, ComponentFactoryResolver, Output, EventEmitter } from "@angular/core";
import { IPublisherMappingsModel, ProviderOrder } from "./publisher.model";
import { PublisherMappingsFormComponent } from "./publisher-mappings-form-modal.component";
import { FilterItemsService } from "../reports";
import { DropdownValue } from "../shared/dropdown.model";

@Component({
    selector: 'publisher-mappings-modal',
    moduleId: module.id,
    templateUrl: 'publisher-mappings-modal.component.html'
})

export class PublisherMappingsComponent {
    sectionCounter: number = 1;
    countryValues: Array<DropdownValue> = [];
    sectionsAreValid: boolean = true;

    @ViewChild('dynamicMappingsInsert', { read: ViewContainerRef }) parent: ViewContainerRef;
    componentFactory: ComponentFactory<PublisherMappingsFormComponent>;
    mappingComponents: PublisherMappingsFormComponent[];

    @Output()
    public publisherMappings: EventEmitter<IPublisherMappingsModel[]> = new EventEmitter<IPublisherMappingsModel[]>();

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private filterItemsService: FilterItemsService) {
        this.mappingComponents = new Array<PublisherMappingsFormComponent>();
    }

    ngOnInit() {
        this.countryValues = this.filterItemsService.getCountries(false);
        this.componentFactory = this.componentFactoryResolver.resolveComponentFactory(PublisherMappingsFormComponent);

        setInterval(() => {
            this.sectionsAreValid = true;
            this.mappingComponents.forEach(c => {
                if (c.selectedCountry == undefined || c.selectedCountry == null || c.selectedCountry == 0)
                    this.sectionsAreValid = false;
                if (c.selectedProvidersInOrder == undefined || c.selectedProvidersInOrder.length < 1)
                    this.sectionsAreValid = false;
            });
        }, 300);
    }

    ngAfterViewInit() {
        this.parent.clear();
        this.addFormComponent();
    }

    addSection() {
        this.sectionCounter++;
        this.addFormComponent();
    }

    private addFormComponent() {
        let c = this.parent.createComponent(this.componentFactory);
        c.instance.removedPublisherMappings.subscribe($event => {
            this.removePublisherMappings($event);
        });
        let notYetSelectedCountries = this.countryValues.map(x => Object.assign({}, x));
        for (let j = 0; j < this.countryValues.length; j++) {
            for (let i = 0; i < this.mappingComponents.length; i++)
                if (this.mappingComponents[i].selectedCountry == this.countryValues[j].value) {
                    let index = notYetSelectedCountries.findIndex(x => x.value == this.countryValues[j].value);
                    notYetSelectedCountries.splice(index, 1);
                }
        }
        c.instance.countryValues = notYetSelectedCountries;
        c.instance.values = this.filterItemsService.getProvidersTreeViewModel();
        this.mappingComponents.push(c.instance);
    }

    onPrevious($event) {
        $('#publisherMappingsModal').modal('hide');
        $('#publisherSettingsModal').modal('show');
    }

    onNext(event) {
        let result = new Array<IPublisherMappingsModel>();
        this.mappingComponents.forEach(c => {
            let r1 = new IPublisherMappingsModel();
            r1.countryId = c.selectedCountry;
            r1.providerIdsOrdered = new Array<ProviderOrder>();
            c.selectedProvidersInOrder.forEach((provider, index) => {
                let po = new ProviderOrder();
                po.providerId = provider;
                po.order = index + 1;
                r1.providerIdsOrdered.push(po);
            });
            result.push(r1);
        });
        this.publisherMappings.emit(result);
        $('#publisherMappingsModal').modal('hide');
    }

    removePublisherMappings(item) {
        let index = this.mappingComponents.findIndex(x => x.selectedCountry == item);
        if (index > -1) {
            this.parent.remove(index);
            this.mappingComponents.splice(index, 1);
            this.sectionCounter--;
        }
    }

    clearModal() {
        this.mappingComponents = [];
        this.parent.clear();
        this.addFormComponent();
        this.sectionCounter = 1;
    }
}


// WEBPACK FOOTER //
// ./src/app/publishers/publisher-mappings-modal.component.ts